// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles for .contact-form-container */
.contact-form-container {
  max-width: 100%;
  margin: 2.5rem auto;
  padding: 1rem;
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.contact-form-container h1 {
  text-align: center;
  color: #247a97;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  color: #247a97;
  font-size: 3rem;
  font-weight: 900;
  font-style: italic;
  align-items: center;
}

.contact-form-container h2 {
  text-align: center;
  color: #247a97;
  margin-bottom: 1rem;
  font-size: 2rem;
}

.contact-form-container form {
  display: flex;
  flex-direction: column;
}

.contact-form-container .contact-form {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 2rem;
  grid-row-gap: 0px;
  margin-top: 3rem;
  font-size: 1rem;
}

.contact-form-container form input::-moz-placeholder, .contact-form-container form textarea::-moz-placeholder {
  font-size: 1rem;
}

.contact-form-container form input::placeholder,
.contact-form-container form textarea::placeholder {
  font-size: 1rem;
}

.form-group {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.form-group input {
  flex: 1;
  max-width: calc(50% - 10px);
}

/* Input and textarea styles */
.contact-form-container input[type="text"],
.contact-form-container input[type="email"],
.contact-form-container textarea,
.contact-form-container select {
  padding: 0.5rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
}

.contact-form-container textarea {
  height: 100px;
}

/* Button styles */
.contact-form-container button[type="submit"] {
  background-color: #76bbe9;
  fill: #ffffff;
  border-color: white;
  color: #ffffff;
  position: relative;
  letter-spacing: 0.5px;
  width: 50%;
  margin: 0 auto;
  transition: transform 0.3s;
  font-size: 1.5rem;
  font-weight: 600;
  border-width: 4px 4px 4px 4px;
  border-style: solid;
  border-radius: 10px 0px 10px 0px;
  padding: 15px 35px 15px 35px;
  box-shadow: 5px 5px 5px 0px
    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);

  &:hover {
    background-color: #247a97;
    cursor: pointer;
    transform: scale(0.9);
    border-color: white;
  }
}

/* Privacy policy styles */
.privacy-policy {
  margin-top: 1rem;
  background: #e8e8e8;
  padding: 1rem;
  border-radius: 4px;
}

.privacy-policy h2 {
  margin-top: 0;
  color: #333;
}

.privacy-policy p {
  color: #666;
  font-size: 1.25rem;
  line-height: 1.75rem;
  text-indent: 1rem;
  padding: 1rem;
}

/* DatePicker styles */
.react-datepicker {
  border: 1px solid #ddd;
  border-radius: 4px;
  display: inline-block;
  padding: 0.5rem;
  margin-bottom: 1rem;
  background-color: white;
  position: relative;
  font-size: 1rem;
}

.react-datepicker__input-container input {
  padding: 0.5rem;
  border: none;
  width: 100%;
  outline: none;
  font-size: inherit;
}

.react-datepicker-popper {
  z-index: 102;
}

.react-datepicker__triangle {
  border-bottom-color: #ddd !important;
}

.react-datepicker__day--selected {
  background-color: #247a97;
  color: white;
}

.react-datepicker__day--hover {
  background-color: #1a5a73;
}

/* Styles for form groups */
.form-group {
  display: flex;
  justify-content: space-between;
}

.form-group input {
  width: 48%; /* Adjust to allow space between inputs */
}

/* Additional responsive adjustments */
@media (min-width: 640px) {
  /* Ensuring form groups are flex containers on larger screens */
  .contact-form-container form .form-group {
    display: flex;
  }

  .contact-form-container form .form-group input {
    width: 48%;
  }
}

/* Responsive adjustments */
@media (min-width: 475px) {
  .contact-form-container {
    margin: 4rem auto;
    padding: 2rem;
  }

  .contact-form-container h1 {
    font-size: 2.5rem;
  }
}

@media (min-width: 640px) {
  .contact-form-container {
    margin: 6rem auto;
    padding: 3rem;
  }

  .contact-form-container h1 {
    font-size: 3rem;
  }
}

@media (min-width: 768px) {
  .contact-form-container {
    margin: 8rem auto;
    padding: 4rem;
  }

  .contact-form-container h1 {
    font-size: 3.5rem;
    text-align: start;
  }
}

@media (max-width: 991px) {
  .contact-form-container .contact-form {
    grid-row: auto;
    grid-template-columns: 1fr;
    grid-row-gap: 2rem;
  }

  .contact-form-container h1 {
    font-size: 5rem;
  }

  .contact-form-container h2 {
    font-size: 2.8rem;
    font-weight: 800;
    width: 100%;
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .contact-form-container .contact-form {
    grid-column-gap: 3rem;
    grid-row-gap: 0px;
    margin-top: 3rem;
    font-size: 2rem;
  }

  .contact-form-container form input::-moz-placeholder, .contact-form-container form textarea::-moz-placeholder {
    font-size: 2.5rem;
  }

  .contact-form-container form input::placeholder,
  .contact-form-container form textarea::placeholder,
  .contact-form-container .service-select {
    font-size: 2.5rem;
  }

  /* Input and textarea styles */
  .contact-form-container input[type="text"],
  .contact-form-container input[type="email"],
  .contact-form-container textarea,
  .contact-form-container .service-select {
    padding: 2.5rem 1rem;
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 100%;
  }

  .contact-form-container textarea {
    height: 100px;
  }

  /* Styles for the date picker */
  .react-datepicker {
    transform: scale(2.8);
    transform-origin: bottom left; /* Adjust as needed */
    margin-left: auto;
    margin-right: auto;
    position: relative;
    left: 50%;
    translate: -50% 0; /* Adjust as needed*/
  }

  .react-datepicker__input-container input {
    font-size: 2.5rem;
  }

  .privacy-policy p {
    font-size: 2.4rem;
    line-height: 1.6;
  }
}

@media (min-width: 1024px) {
  .contact-form-container {
    margin: 10rem auto;
    padding: 5rem;
  }

  .contact-form-container h1 {
    font-size: 4rem;
  }

  .contact-form-container .service-select {
    font-size: 1rem;
  }
}

@media (min-width: 1280px) {
  .contact-form-container {
    margin: 12rem auto;
    padding: 6rem;
  }

  .contact-form-container h1 {
    font-size: 4.5rem;
  }
}

@media (min-width: 1536px) {
  .contact-form-container {
    margin: 14rem auto;
    padding: 7rem;
  }

  .contact-form-container h1 {
    font-size: 5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/Contact.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EAEE,eAAe;AACjB;;AAHA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,OAAO;EACP,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;;;;EAIE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;EAC5B;0DACwD;;EAExD;IACE,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;EACrB;AACF;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU,EAAE,yCAAyC;AACvD;;AAEA,sCAAsC;AACtC;EACE,+DAA+D;EAC/D;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IAGE,iBAAiB;EACnB;;EAJA;;;IAGE,iBAAiB;EACnB;;EAEA,8BAA8B;EAC9B;;;;IAIE,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA,+BAA+B;EAC/B;IACE,qBAAqB;IACrB,6BAA6B,EAAE,qBAAqB;IACpD,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,iBAAiB,EAAE,oBAAoB;EACzC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Base styles for .contact-form-container */\n.contact-form-container {\n  max-width: 100%;\n  margin: 2.5rem auto;\n  padding: 1rem;\n  background: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.contact-form-container h1 {\n  text-align: center;\n  color: #247a97;\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: center;\n  color: #247a97;\n  font-size: 3rem;\n  font-weight: 900;\n  font-style: italic;\n  align-items: center;\n}\n\n.contact-form-container h2 {\n  text-align: center;\n  color: #247a97;\n  margin-bottom: 1rem;\n  font-size: 2rem;\n}\n\n.contact-form-container form {\n  display: flex;\n  flex-direction: column;\n}\n\n.contact-form-container .contact-form {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: 1fr;\n  grid-column-gap: 2rem;\n  grid-row-gap: 0px;\n  margin-top: 3rem;\n  font-size: 1rem;\n}\n\n.contact-form-container form input::placeholder,\n.contact-form-container form textarea::placeholder {\n  font-size: 1rem;\n}\n\n.form-group {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.form-group input {\n  flex: 1;\n  max-width: calc(50% - 10px);\n}\n\n/* Input and textarea styles */\n.contact-form-container input[type=\"text\"],\n.contact-form-container input[type=\"email\"],\n.contact-form-container textarea,\n.contact-form-container select {\n  padding: 0.5rem;\n  margin-bottom: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  width: 100%;\n}\n\n.contact-form-container textarea {\n  height: 100px;\n}\n\n/* Button styles */\n.contact-form-container button[type=\"submit\"] {\n  background-color: #76bbe9;\n  fill: #ffffff;\n  border-color: white;\n  color: #ffffff;\n  position: relative;\n  letter-spacing: 0.5px;\n  width: 50%;\n  margin: 0 auto;\n  transition: transform 0.3s;\n  font-size: 1.5rem;\n  font-weight: 600;\n  border-width: 4px 4px 4px 4px;\n  border-style: solid;\n  border-radius: 10px 0px 10px 0px;\n  padding: 15px 35px 15px 35px;\n  box-shadow: 5px 5px 5px 0px\n    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);\n\n  &:hover {\n    background-color: #247a97;\n    cursor: pointer;\n    transform: scale(0.9);\n    border-color: white;\n  }\n}\n\n/* Privacy policy styles */\n.privacy-policy {\n  margin-top: 1rem;\n  background: #e8e8e8;\n  padding: 1rem;\n  border-radius: 4px;\n}\n\n.privacy-policy h2 {\n  margin-top: 0;\n  color: #333;\n}\n\n.privacy-policy p {\n  color: #666;\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n  text-indent: 1rem;\n  padding: 1rem;\n}\n\n/* DatePicker styles */\n.react-datepicker {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  display: inline-block;\n  padding: 0.5rem;\n  margin-bottom: 1rem;\n  background-color: white;\n  position: relative;\n  font-size: 1rem;\n}\n\n.react-datepicker__input-container input {\n  padding: 0.5rem;\n  border: none;\n  width: 100%;\n  outline: none;\n  font-size: inherit;\n}\n\n.react-datepicker-popper {\n  z-index: 102;\n}\n\n.react-datepicker__triangle {\n  border-bottom-color: #ddd !important;\n}\n\n.react-datepicker__day--selected {\n  background-color: #247a97;\n  color: white;\n}\n\n.react-datepicker__day--hover {\n  background-color: #1a5a73;\n}\n\n/* Styles for form groups */\n.form-group {\n  display: flex;\n  justify-content: space-between;\n}\n\n.form-group input {\n  width: 48%; /* Adjust to allow space between inputs */\n}\n\n/* Additional responsive adjustments */\n@media (min-width: 640px) {\n  /* Ensuring form groups are flex containers on larger screens */\n  .contact-form-container form .form-group {\n    display: flex;\n  }\n\n  .contact-form-container form .form-group input {\n    width: 48%;\n  }\n}\n\n/* Responsive adjustments */\n@media (min-width: 475px) {\n  .contact-form-container {\n    margin: 4rem auto;\n    padding: 2rem;\n  }\n\n  .contact-form-container h1 {\n    font-size: 2.5rem;\n  }\n}\n\n@media (min-width: 640px) {\n  .contact-form-container {\n    margin: 6rem auto;\n    padding: 3rem;\n  }\n\n  .contact-form-container h1 {\n    font-size: 3rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .contact-form-container {\n    margin: 8rem auto;\n    padding: 4rem;\n  }\n\n  .contact-form-container h1 {\n    font-size: 3.5rem;\n    text-align: start;\n  }\n}\n\n@media (max-width: 991px) {\n  .contact-form-container .contact-form {\n    grid-row: auto;\n    grid-template-columns: 1fr;\n    grid-row-gap: 2rem;\n  }\n\n  .contact-form-container h1 {\n    font-size: 5rem;\n  }\n\n  .contact-form-container h2 {\n    font-size: 2.8rem;\n    font-weight: 800;\n    width: 100%;\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n\n  .contact-form-container .contact-form {\n    grid-column-gap: 3rem;\n    grid-row-gap: 0px;\n    margin-top: 3rem;\n    font-size: 2rem;\n  }\n\n  .contact-form-container form input::placeholder,\n  .contact-form-container form textarea::placeholder,\n  .contact-form-container .service-select {\n    font-size: 2.5rem;\n  }\n\n  /* Input and textarea styles */\n  .contact-form-container input[type=\"text\"],\n  .contact-form-container input[type=\"email\"],\n  .contact-form-container textarea,\n  .contact-form-container .service-select {\n    padding: 2.5rem 1rem;\n    margin-bottom: 1rem;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    width: 100%;\n  }\n\n  .contact-form-container textarea {\n    height: 100px;\n  }\n\n  /* Styles for the date picker */\n  .react-datepicker {\n    transform: scale(2.8);\n    transform-origin: bottom left; /* Adjust as needed */\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    left: 50%;\n    translate: -50% 0; /* Adjust as needed*/\n  }\n\n  .react-datepicker__input-container input {\n    font-size: 2.5rem;\n  }\n\n  .privacy-policy p {\n    font-size: 2.4rem;\n    line-height: 1.6;\n  }\n}\n\n@media (min-width: 1024px) {\n  .contact-form-container {\n    margin: 10rem auto;\n    padding: 5rem;\n  }\n\n  .contact-form-container h1 {\n    font-size: 4rem;\n  }\n\n  .contact-form-container .service-select {\n    font-size: 1rem;\n  }\n}\n\n@media (min-width: 1280px) {\n  .contact-form-container {\n    margin: 12rem auto;\n    padding: 6rem;\n  }\n\n  .contact-form-container h1 {\n    font-size: 4.5rem;\n  }\n}\n\n@media (min-width: 1536px) {\n  .contact-form-container {\n    margin: 14rem auto;\n    padding: 7rem;\n  }\n\n  .contact-form-container h1 {\n    font-size: 5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
